import React, {useState} from 'react';
import {Button, Form, Input, message, Spin} from 'antd';
import {useMutation} from 'react-query';
import {LockOutlined, UserOutlined} from '@ant-design/icons';
import {SocialLoginBTNS} from "../social";
import {SignInProfile} from "../../../api/profile";


export const SignIn = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    const SignInMutation = useMutation(
        (data) => SignInProfile(data),
        {
            onSuccess: () => {
                setIsLoading(true);
                message.success(`Авторизация прошла успешно, вы будете переадресованы через несколько секунд`);
                setTimeout(() => {
                    window.location.href = '/';
                }, 2500);
            },
            onError: (e) => {
                console.error(`[SignInMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    const onFinish = (props) => {
        SignInMutation.mutate(props);
    }

    return (
        <div className={`component sign_in`}>
            <h2>Авторизация в платформе</h2>
            <div className="sign_in--wrp">
                <Spin spinning={isLoading}>
                    <Form layout={"vertical"} name={`sign_in`} onFinish={onFinish}>
                        <Form.Item
                            label={`Эл. почта`}
                            name="email"
                            rules={[
                                {required: true, message: 'Укажите ваш почтовый адрес'},
                                {type: 'email', message: 'Укажите корректный почтовый адрес'},
                            ]}
                        >
                            <Input
                                prefix={<UserOutlined/>}
                                type={`email`}
                            />
                        </Form.Item>
                        <Form.Item
                            label={`Пароль`}
                            name="password"
                            rules={[
                                {required: true, message: 'Укажите ваш пароль'}
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined/>}
                            />
                        </Form.Item>
                        <a className="link bold" href={'/profile/forgot'}>Забыли учетную запись?</a>
                        <Form.Item className={`sign_in--actions`}>
                            <a href={`/profile/sign_up`}>Создать аккаунт</a>
                            <Button type={`primary`} htmlType={"submit"}
                                    loading={SignInMutation.isLoading}>Войти</Button>
                        </Form.Item>
                    </Form>
                    <SocialLoginBTNS/>
                </Spin>
            </div>
        </div>
    );
};

export default SignIn;